import { render, staticRenderFns } from "./career-details.vue?vue&type=template&id=000464ec&scoped=true&"
import script from "./career-details.vue?vue&type=script&lang=js&"
export * from "./career-details.vue?vue&type=script&lang=js&"
import style0 from "./career-details.vue?vue&type=style&index=0&id=000464ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000464ec",
  null
  
)

export default component.exports